import { BarChart, BarSeriesOption } from 'echarts/charts';
import {
  GridComponent,
  GridComponentOption,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  GridComponent,
  BarChart,
  CanvasRenderer,
  TooltipComponent,
  LegendComponent,
]);

type EChartsOption = echarts.ComposeOption<
  GridComponentOption | BarSeriesOption
> & {
  yAxis: any; // to fix yAxis.textStyle type waring
};

export const useBasicBarChart = () => {
  const generateChartInstance = (chartID: string) => {
    if (!chartID) return null;
    const el = document.getElementById(chartID);
    if (!el) return null;
    return echarts.init(el);
  };

  const drawChart = (
    chartRef,
    xList: Array<string | number>,
    yList: Array<string | number>,
    options?: EChartsOption
  ) => {
    if (chartRef) {
      const xAxisOption = options.xAxis || {};
      const yAxisOption = options.yAxis || {};
      const seriesOption = options.series;
      delete options.xAxis;
      delete options.yAxis;
      delete options.series;

      const mergeOptions = {
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          data: xList,
          axisLine: {
            lineStyle: {
              color: '#F1F1F1',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#202020',
            },
          },
          axisTick: {
            show: false,
          },
          ...xAxisOption,
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#F1F1F1',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#202020',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#F1F1F1',
            },
          },
          ...yAxisOption,
        },
        series: seriesOption
          ? seriesOption
          : [
              {
                data: yList,
                type: 'bar',
                itemStyle: {
                  color: '#6AE5BB',
                },
              },
            ],
        ...(options || {}),
      };

      chartRef.setOption(mergeOptions);
    }
  };

  const drawStackedColumnChart = (
    chartRef,
    xList: Array<string | number>,
    series: any[],
    options?: EChartsOption
  ) => {
    if (chartRef) {
      chartRef.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: xList,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: series,
        ...options,
      });
    }
  };

  return { generateChartInstance, drawChart, drawStackedColumnChart };
};
